import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-legal-icon/jb-legal-icon.css.ts
var jb_legal_icon_css_default = i`:host{font-family:var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);font-weight:var(--theme-font-regular-weight, 400)}:host{font-size:var(--theme-typo-p-mini-highlight-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-highlight-desktop-lineheight, 1.25rem)}:host{align-items:center;color:inherit;cursor:pointer;display:var(--display, inline-flex);gap:var(--theme-spacing-3xs)}:host(:hover) svg{transform:scale3d(1.1, 1.1, 1.1)}svg{block-size:24px;display:inline-block;inline-size:24px;margin-inline-end:-5px;overflow:visible;padding:2px;transition:transform .3s ease-in-out;translate:0 -1px}`;

export {
  jb_legal_icon_css_default
};
